/* Theme scripts: cart drawer, product options, bundle packs, offer countdown, mobile menu */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  R.root = R.root || '/';
  R.cart = R.cart || '/cart';
  R.cartAdd = R.cartAdd || '/cart/add';
  R.cartChange = R.cartChange || '/cart/change';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- money ---------- */
  function group(n, thousands, decimal) {
    var parts = n.toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + parts[1];
  }
  function money(cents) {
    var v = cents / 100;
    var fmt = T.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return group(v, ',', '.');
        case 'amount_no_decimals': return group(v, ',', '.').split('.')[0];
        case 'amount_with_comma_separator': return group(v, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(v, '.', ',').split(',')[0];
        case 'amount_with_space_separator': return group(v, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(v, ' ', '.').split('.')[0];
        case 'amount_with_apostrophe_separator': return group(v, "'", '.');
        default: return group(v, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3600);
  }

  /* ---------- offer countdown (only runs for a real end date set in Theme settings) ---------- */
  (function () {
    var o = T.offer || {};
    if (!o.enabled || !o.endsAt) return;
    var end = new Date(o.endsAt).getTime();
    if (isNaN(end)) return;
    var timer;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      var els = $$('[data-offer-ann]').concat($$('[data-offer-pill]'));
      if (left <= 0) {
        els.forEach(function (el) { el.hidden = true; });
        clearInterval(timer);
        return;
      }
      var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5),
          m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
      var out = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      $$('[data-countdown]').forEach(function (el) { el.textContent = out; });
      els.forEach(function (el) { el.hidden = false; });
    }
    timer = setInterval(tick, 1000);
    tick();
  })();

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-drawer]');
  var veil = $('[data-cart-veil]');
  var lastFocus = null;

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    if (veil) veil.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    var c = $('[data-cart-close]');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (veil) veil.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function applySections(sections) {
    var applied = false;
    if (!sections) return false;
    if (sections['cart-drawer']) {
      var fresh = $('[data-cart-content]', parseHTML(sections['cart-drawer']));
      var cur = $('[data-cart-content]');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        var n = parseInt(fresh.getAttribute('data-item-count') || '0', 10);
        cur.setAttribute('data-item-count', n);
        setCount(n);
        applied = true;
      }
    }
    if (sections['announcement-bar']) {
      var freshAnn = $('[data-ann]', parseHTML(sections['announcement-bar']));
      var curAnn = $('[data-ann]');
      if (freshAnn && curAnn) curAnn.innerHTML = freshAnn.innerHTML;
    }
    return applied;
  }
  function refreshCart() {
    var url = R.cart + '?sections=cart-drawer,announcement-bar&_=' + Date.now();
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!applySections(j)) throw new Error('cart refresh failed');
      });
  }
  function jsonOrThrow(r) {
    return r.json().then(function (j) {
      if (!r.ok) {
        var err = new Error(j.description || j.message || 'Something went wrong. Please try again.');
        err.userFacing = r.status === 422;
        throw err;
      }
      return j;
    });
  }
  function addItems(items) {
    return fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,announcement-bar' })
    }).then(jsonOrThrow);
  }
  function changeLine(key, qty) {
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: 'cart-drawer,announcement-bar' })
    }).then(jsonOrThrow).then(function (res) {
      if (!applySections(res.sections)) return refreshCart();
    }).catch(function (err) {
      toast(err.message);
      return refreshCart().catch(function () { window.location.href = R.cart; });
    });
  }
  /* Last-resort add: a Shopify cart link (/cart/VARIANT:QTY,VARIANT:QTY) adds the items and opens the cart page. */
  function permalink(items) {
    return R.cart.replace(/\/$/, '') + '/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
  }

  document.addEventListener('click', function (e) {
    if (drawer && e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || (veil && e.target === veil)) { closeDrawer(); return; }
    var b = e.target.closest('[data-a="change"]');
    if (b) {
      e.preventDefault();
      changeLine(b.getAttribute('data-key'), parseInt(b.getAttribute('data-qty'), 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    var mt = $('[data-menu-toggle]'), mn = $('#mobile-nav');
    if (mt && mn && !mn.hidden) { mn.hidden = true; mt.setAttribute('aria-expanded', 'false'); }
  });

  /* ---------- mobile menu ---------- */
  (function () {
    var mt = $('[data-menu-toggle]'), mn = $('#mobile-nav');
    if (!mt || !mn) return;
    mt.addEventListener('click', function () {
      var open = mn.hidden;
      mn.hidden = !open;
      mt.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  /* ---------- product: options, packs, add to cart ---------- */
  function initProduct(root) {
    var dataEl = $('[data-variants]', root);
    var form = $('form.buy-form', root);
    if (!dataEl || !form) return;

    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-qty-input]', form);
    var qtyOut = $('[data-qty-out]', form);
    var atc = $('[data-atc]', form);
    var atcLabel = $('[data-atc-label]', form);
    var atcTotal = $('[data-atc-total]', form);
    var stickyBtn = $('[data-sticky-atc]', root);
    var units = $$('[data-unit]', root);
    var track = $('[data-track]', root);
    var thumbs = $$('[data-thumb]', root);
    var bundlesOn = root.getAttribute('data-bundles') === 'true';
    var bundle = {
      2: parseInt(root.getAttribute('data-bundle-2'), 10) || 0,
      3: parseInt(root.getAttribute('data-bundle-3'), 10) || 0
    };
    var pack = 1, qty = 1, touched = {};

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function values(u) {
      return $$('[data-opt]', units[u]).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : '';
      });
    }
    function findVariant(u) {
      var vals = values(u);
      if (!vals.length) return byId(idInput.value) || variants[0];
      var key = vals.join('\u0001');
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.join('\u0001') === key) return variants[i];
      }
      return null;
    }
    function copyUnit(from, to) {
      var src = values(from);
      $$('[data-opt]', units[to]).forEach(function (fs, k) {
        $$('input', fs).forEach(function (inp) { inp.checked = inp.value === src[k]; });
      });
    }
    function showRows() {
      var n = bundlesOn ? pack : 1;
      units.forEach(function (el, i) {
        var wasHidden = el.hidden;
        el.hidden = i >= n;
        if (wasHidden && !el.hidden && i > 0 && !touched[i]) copyUnit(0, i);
      });
    }
    function showMedia(id) {
      if (!track || id === null || id === undefined) return;
      var slides = $$('[data-media-id]', track);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) {
          track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
          return;
        }
      }
    }

    function update() {
      var n = bundlesOn ? pack : 1;
      var chosen = [];
      for (var u = 0; u < n; u++) chosen.push(findVariant(u));

      var sum = 0;
      chosen.forEach(function (v) { sum += v ? v.price : 0; });
      var first = chosen[0];
      var total = bundlesOn ? sum : sum * qty;
      var was = 0;
      if (bundlesOn && n > 1 && bundle[n]) { total = bundle[n]; was = sum; }
      else if (first && first.compare > first.price) { was = first.compare * (bundlesOn ? 1 : qty); }

      /* availability, using real inventory only */
      var need = {};
      chosen.forEach(function (v) { if (v) need[v.id] = (need[v.id] || 0) + (bundlesOn ? 1 : qty); });
      var problem = '', low = '';
      chosen.forEach(function (v) {
        if (!v) { problem = 'Unavailable'; return; }
        if (!v.available) { problem = 'Sold out'; return; }
        if (v.stock !== null && v.stock < need[v.id]) { problem = 'Only ' + Math.max(v.stock, 0) + ' available'; return; }
        if (v.stock !== null && v.stock > 0 && v.stock <= (T.lowStock || 10)) low = 'Only ' + v.stock + ' left';
      });
      var canBuy = !problem;

      $$('[data-price]', root).forEach(function (el) { el.textContent = money(total); });
      var cmp = $('[data-compare]', root), sv = $('[data-save]', root);
      if (cmp && sv) {
        if (was > total) {
          cmp.textContent = money(was); cmp.hidden = false;
          sv.textContent = 'Save ' + money(was - total); sv.hidden = false;
        } else { cmp.hidden = true; sv.hidden = true; }
      }
      if (atcTotal) atcTotal.textContent = money(total);
      var label = canBuy ? 'Add to cart' : problem;
      if (atcLabel) atcLabel.textContent = label;
      atc.disabled = !canBuy;
      if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = !canBuy; }

      var dot = $('[data-stock-dot]', root), txt = $('[data-stock-text]', root);
      if (dot) dot.className = 'dot' + (problem ? ' out' : (low ? ' low' : ''));
      if (txt) txt.textContent = problem || low || 'In stock';

      if (first) idInput.value = first.id;
      if (qtyInput) qtyInput.value = qty;
      if (qtyOut) qtyOut.textContent = qty;

      /* legends and labels */
      units.forEach(function (unit, i) {
        $$('[data-legend]', unit).forEach(function (lg) {
          var name = lg.getAttribute('data-name');
          var title = (bundlesOn && pack > 1) ? name + ' for item ' + (i + 1) : name;
          if (lg.firstChild && lg.firstChild.nodeType === 3) lg.firstChild.nodeValue = title + ': ';
          var lab = $('[data-opt-label]', lg);
          var checked = $('input:checked', lg.parentNode);
          if (lab && checked) lab.textContent = checked.value;
        });
      });

      /* pack cards */
      if (bundlesOn && first) {
        var base = first.price;
        var p1 = $('[data-pack-price="1"]', root);
        if (p1) p1.textContent = money(base);
        [2, 3].forEach(function (k) {
          var pp = $('[data-pack-price="' + k + '"]', root), pw = $('[data-pack-was="' + k + '"]', root), ps = $('[data-pack-save="' + k + '"]', root);
          var full = base * k, save = full - bundle[k];
          if (pp) pp.textContent = money(bundle[k]);
          if (pw) pw.textContent = money(full);
          if (ps) { ps.textContent = 'Save ' + money(save); ps.hidden = save <= 0; }
        });
      }
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest('[data-packs]')) {
        pack = parseInt(t.value, 10) || 1;
        showRows();
        update();
        return;
      }
      var unit = t.closest('[data-unit]');
      if (unit) {
        var u = parseInt(unit.getAttribute('data-unit'), 10) - 1;
        if (u > 0) touched[u] = true;
        if (u === 0) {
          for (var i = 1; i < units.length; i++) if (!touched[i]) copyUnit(0, i);
        }
        update();
        if (u === 0) {
          var v = findVariant(0);
          if (v) {
            showMedia(v.media);
            if (window.history && history.replaceState) {
              try { history.replaceState(null, '', '?variant=' + v.id); } catch (err) { /* ignore */ }
            }
          }
        }
      }
    });

    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.min(10, Math.max(1, qty + parseInt(b.getAttribute('data-qty'), 10)));
        update();
      });
    });

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { showMedia(b.getAttribute('data-thumb')); });
    });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, { passive: true });
    }

    var busy = false;
    function submitAdd() {
      if (busy || atc.disabled) return;
      var n = bundlesOn ? pack : 1;
      var items = [], counts = {}, order = [];
      for (var u = 0; u < n; u++) {
        var v = findVariant(u);
        if (!v) return;
        if (!(v.id in counts)) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += bundlesOn ? 1 : qty;
      }
      order.forEach(function (id) { items.push({ id: id, quantity: counts[id] }); });

      busy = true;
      atc.setAttribute('aria-busy', 'true');
      if (!window.fetch) { window.location.href = permalink(items); return; }
      addItems(items).then(function (res) {
        /* the items are in the cart now: show them, or fall back to the cart page */
        return Promise.resolve(applySections(res.sections) || refreshCart()).then(openDrawer);
      }, function (err) {
        if (err && err.userFacing) { toast(err.message); return; }
        window.location.href = permalink(items);
        return new Promise(function () {});
      }).catch(function () {
        window.location.href = R.cart;
        return new Promise(function () {});
      }).then(function () {
        busy = false;
        atc.removeAttribute('aria-busy');
        update();
      });
    }

    /* Capture phase on window: our handler runs before any other script can swallow the click. */
    window.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-atc], [data-sticky-atc]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submitAdd();
    }, true);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitAdd();
    }, true);

    /* sticky add-to-cart bar: appears after the main button scrolls away, hides at the closing section */
    var bar = $('[data-sticky]', root);
    var endEl = $('[data-sticky-end]') || $('footer');
    if (bar) {
      var queued = false;
      var upd = function () {
        queued = false;
        var passed = atc.getBoundingClientRect().bottom < 0;
        var atEnd = endEl ? endEl.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('show', passed && !atEnd);
      };
      window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }

    showRows();
    update();
  }

  $$('[data-product]').forEach(initProduct);
})();